module.exports = __webpack_public_path__ + "static/images/containers/BattleRooms/components/Squad/components/Vehicle/images/vehicle-slot.59a4769e.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/Squad/components/Vehicle/images/vehicle-slot.png
// module id = 2739
// module chunks = 11